module.exports = __webpack_public_path__ + "static/media/unit.02cf0b0d.svg";